var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18582 0.744995C3.56055 0.744995 3.05367 1.25187 3.05367 1.87714V3.02923H2.57589C1.15326 3.02923 0 4.18725 0 5.61575V14.6686C0 16.0971 1.15326 17.2551 2.57589 17.2551H12.8794C14.3021 17.2551 15.4553 16.0971 15.4553 14.6686V5.61575C15.4553 4.18725 14.3021 3.02923 12.8794 3.02923H12.5263V1.78711C12.5263 1.21157 12.0598 0.744995 11.4842 0.744995C10.9087 0.744995 10.4421 1.21157 10.4421 1.78711V3.02923H5.31796V1.87714C5.31796 1.25187 4.81108 0.744995 4.18582 0.744995ZM2.57589 5.02923H12.8794C13.1897 5.02923 13.4553 5.28405 13.4553 5.61575V14.6686C13.4553 15.0003 13.1897 15.2551 12.8794 15.2551H2.57589C2.26559 15.2551 2 15.0003 2 14.6686V5.61575C2 5.28405 2.26559 5.02923 2.57589 5.02923ZM6.59556 7.60081C6.59556 7.02289 6.12707 6.5544 5.54915 6.5544H4.20746C3.62954 6.5544 3.16104 7.02289 3.16104 7.60081C3.16104 8.17873 3.62954 8.64722 4.20746 8.64722H5.54915C6.12707 8.64722 6.59556 8.17873 6.59556 7.60081Z",
    fill: "#0090FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.c6e421926f1f815b12e47968d811b63c.svg";
export { ForwardRef as ReactComponent };